import React from 'react';

export default function (props) {
	return (
		<div
			style={{
				...props.style,
			}}
			className={props.className}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={props.width || props.size}
				height={props.height || props.size}
				viewBox="0 0 58 58" style={{enableBackground:"new 0 0 58 58"}}>
				<rect style={{fill:"none", width: "58", height: "58"}}/>
				<line style={{fill:"none", stroke:props.stroke || "#424A60", strokeWidth:5, strokeMiterlimit:10}} x1="44" y1="14" x2="14.302" y2="43.698" />
				<line style={{fill:"none", stroke: props.stroke || "#424A60", strokeWidth:5, strokeMiterlimit:10}} x1="44" y1="43.698" x2="14.302" y2="14" />

			</svg>

		</div>
	);
}
